import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b0a9d5e")

_pushScopeId("data-v-3b0a9d5e")
const _hoisted_1 = { id: "imageEditor" }
const _hoisted_2 = { class: "label heading" }
const _hoisted_3 = { class: "settings-row imageList" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "close", -1)
const _hoisted_5 = { class: "imageName" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Dimensions", -1)
const _hoisted_9 = { class: "settings-row" }
const _hoisted_10 = { class: "input-box" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_12 = { class: "input-box" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "W", -1)
const _hoisted_14 = { class: "settings-row" }
const _hoisted_15 = { class: "input-box" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
const _hoisted_17 = { class: "input-box" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "H", -1)
const _hoisted_19 = { class: "settings-row" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Keep ratio", -1)
const _hoisted_21 = { class: "settings-row" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Dithering", -1)
const _hoisted_23 = { class: "intensity-value" }
const _hoisted_24 = {
  key: 0,
  class: "settings-row"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Pause by default", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.gifMode ? "GIF" : "Image") + " ", 1 /* TEXT */),
      _createVNode("input", {
        type: "text",
        class: "imageNameInput",
        onInput: _cache[1] || (_cache[1] = val => _ctx.component.setImage(val.target.value)),
        value: _ctx.component.image
      }, null, 40, ["value"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regImages
          .map(key => _ctx.images[key])
          .filter(image => image.isGif == _ctx.gifMode), (img) => {
        return (_openBlock(), _createBlock("div", {
          class: ["imageBox", _ctx.component.image == img.name ? 'active' : ''],
          key: img.name,
          style: { backgroundImage: `url(${img.data.src})` },
          onClick: $event => (_ctx.component.setImage(img.name))
        }, [
          _createVNode("div", {
            class: "delImage",
            onClick: _withModifiers($event => (_ctx.unregisterImage(img.name)), ["stop"])
          }, [
            _hoisted_4
          ], 8, ["onClick"]),
          _createVNode("div", _hoisted_5, _toDisplayString(img.name), 1)
        ], 14, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("div", {
      class: "btn",
      onClick: _cache[3] || (_cache[3] = $event => (_ctx.triggerFileSelector()))
    }, [
      _hoisted_6,
      _createTextVNode(" Upload " + _toDisplayString(_ctx.gifMode ? "GIF" : "image") + " ", 1 /* TEXT */),
      _createVNode("input", {
        type: "file",
        ref: "fileDownload",
        accept: _ctx.gifMode ? '.gif' : '.png,.jpg',
        style: {"display":"none"},
        multiple: "",
        onChange: _cache[2] || (_cache[2] = $event => (_ctx.checkForUpload()))
      }, null, 40, ["accept"])
    ]),
    _hoisted_7,
    _hoisted_8,
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[4] || (_cache[4] = $event => (_ctx.inputTransformer($event, _ctx.component.x))),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.component.x = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.x,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[6] || (_cache[6] = $event => (_ctx.inputTransformer($event, _ctx.component.width))),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.component.width = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.width,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_13
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[8] || (_cache[8] = $event => (_ctx.inputTransformer($event, _ctx.component.y))),
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.component.y = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.y,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_16
      ]),
      _createVNode("div", _hoisted_17, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[10] || (_cache[10] = $event => (_ctx.inputTransformer($event, _ctx.component.height))),
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.component.height = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.height,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_18
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      _hoisted_20,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.component.keepImageRatio = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.component.keepImageRatio]
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _hoisted_22,
      _withDirectives(_createVNode("input", {
        class: "intensity-range",
        type: "range",
        min: "0",
        max: "100",
        step: "1",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (_ctx.component.ditheringIntensity = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.component.ditheringIntensity,
          void 0,
          { number: true }
        ]
      ]),
      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.component.ditheringIntensity) + "%", 1)
    ]),
    (_ctx.gifMode)
      ? (_openBlock(), _createBlock("div", _hoisted_24, [
          _hoisted_25,
          _withDirectives(_createVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.component.pausedByDefault = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.component.pausedByDefault]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})